import { FunctionComponent, ReactNode, useState } from "react";
import TextFieldAtom from "../../../atoms/textfield";
import {
  LabelPairedEyeSmBoldIcon,
  LabelPairedLockSmBoldIcon,
  LabelPairedEyeSlashSmBoldIcon,
} from "@deriv/quill-icons";

export type PasswordFieldType = {
  id?: string;
  name?: string;
  className?: string;
  label?: string;
  placeholder?: string;
  showCharacterCounter?: boolean;
  message?: string;

  /** Variant props */
  indicator?: "neutral" | "fail" | "success";
  state?: "default" | "disabled";
  type?: "outline" | "fill";
  size?: "lg" | "md" | "sm";
  textAlignment?: "left" | "center";

  /** Custom props */
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
  iconStatus?: ReactNode;
  labelLeft?: string;
  isRequired?: boolean;
  optionalText?: string;
  maxLength?: number;
  value?: string | number;
  onChange?: (value: string | number) => void;
  messages?: {
    text: string;
    type: "neutral" | "fail" | "success";
    icon?: ReactNode;
  }[];
  variant?: "labelled" | "labelless";
};

export const PasswordField: FunctionComponent<PasswordFieldType> = (props) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => {
    if (props.state !== "disabled") {
      setShowPassword((prev) => !prev);
    }
  };

  const eyeIcon = showPassword ? (
    <LabelPairedEyeSlashSmBoldIcon
      className="quill-ui-next-pointer"
      onClick={handleTogglePassword}
    />
  ) : (
    <LabelPairedEyeSmBoldIcon
      className="quill-ui-next-pointer"
      onClick={handleTogglePassword}
    />
  );

  return (
    <TextFieldAtom
      label={"Password"}
      placeholder={"Enter your password"}
      {...props}
      inputType={showPassword ? "text" : "password"}
      iconLeft={<LabelPairedLockSmBoldIcon />}
      iconRight={eyeIcon}
      showStatusIcon
    />
  );
};

PasswordField.displayName = "PasswordField";

export default PasswordField;
